import React, { useState } from 'react';
import {EditOutlined} from '@ant-design/icons';
import { Button, Modal, Form, Input, Select } from 'antd';
const {Option}=Select
const TaskUpdateForm = ({ visible, onCreate, onCancel, record }) => {
  const [form] = Form.useForm();
  let taskData = record
  const [taskID]=useState(taskData.TaskID)
  const [taskStatus]=useState(taskData.TaskStatus)
  

  return (
    <Modal
      visible={visible}
      title="Update Task"
      okText="Update"
      cancelText="Cancel"
      onCancel={onCancel}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            form.resetFields();
            onCreate(values);
          })
          .catch((info) => {
            console.log('Validate Failed:', info);
          });
      }}
    >
      <Form
        form={form}
        layout="vertical"
        name="TaskUpdate"
        initialValues={{
            TaskID:taskID,
            TaskStatus:taskStatus,
        }}
      >
        <Form.Item
          name="TaskID"
          label="Task ID"
        >
            <Input disabled/>
        </Form.Item>

        <Form.Item name='TaskStatus' label="Task Status">
            <Select>
              <Option value ={0} >waiting</Option>
              <Option value ={1} >in process</Option>
              <Option value ={2} >finished</Option>
            </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

const TaskUpdate = (props) => {

  const [visible, setVisible] = useState(false);
  const onCreate = (values) => {
    props.updateTask(values)
    setVisible(false);
  };

  return (
    <div>
      <Button
        type="primary"
        onClick={() => {
          setVisible(true);
        }}

        icon={<EditOutlined />}
      >
        
      </Button>
      <TaskUpdateForm
        visible={visible}
        onCreate={onCreate}
        onCancel={() => {
          setVisible(false);
        }}
        record={props.record}
      />
    </div>
  );
};

export default TaskUpdate